import { Navigate } from "react-router-dom";
import { BarChart3 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { EmptyState, PageHeader } from "@/components/Bits";

export default function Ranking() {
  const { leagueId } = useAuth();
  if (leagueId) return <Navigate to={`/ligues/${leagueId}/classement`} replace />;
  return (
    <>
      <PageHeader title="Classement" />
      <EmptyState icon={BarChart3} title="Aucun classement" text="Rejoignez ou créez une ligue pour voir votre classement." cta="Créer une ligue" to="/ligues/nouvelle" testId="ranking-empty" />
    </>
  );
}
